import { AfterViewInit, Component, Input } from '@angular/core';

@Component({
  selector: 'app-packagetour-menutab',
  templateUrl: './packagetour-menutab.component.html',
  styleUrls: ['./packagetour-menutab.component.css']
})
export class PackagetourMenutabComponent implements AfterViewInit {
  @Input() isEdit: boolean = false;
  @Input() nameMenu: string = '';
  @Input() branchofficeSlug: string = '';
  @Input() checkId: any = '';
  @Input() isCotization: boolean = false;

  constructor() {}

  ngAfterViewInit(): void {}
}
